export default __webpack_public_path__ + "images/9K.b652db1.png";